import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedAnticiposComponent {
  data
  desplegar = false
  idColaborador
  idProyecto
  comprobaciones
  informacion
  permiteSolicitar = false
  totalAnticipos = 0
  viaje
  viaticoId
  onChange

  constructor ($q, ViaticosSolicitudAnticipoService) {
    this.$q = $q
    this.ViaticosSolicitudAnticipoService = ViaticosSolicitudAnticipoService
  }

  $onChanges (changes) {
    if (changes.comprobaciones && !changes.comprobaciones.isFirstChange()) {
      this.inicializar()
    }
  }

  $onInit () {
    this.data = this.data ? this.data : []
    if (!this.viaticoId) return

    this.inicializar()
  }

  actualizar (item, data) {
    if (!data) {
      this.data.splice(this.data.findIndex((solicitud) => solicitud.solicitud_id === item.solicitud_id), 1)
    } else {
      Object.assign(item, data)
    }
    this.inicializar()
    this.onChange({$event: {detail: this.data}})
  }

  agregar (data) {
    this.data = [...this.data, data]
    this.inicializar()
    this.onChange({$event: {detail: this.data}})
  }

  inicializar () {
    this.permiteSolicitar = this.data.every((solicitud) => solicitud.autorizado || solicitud.cancelado) && this.comprobaciones.every((solicitud) => !solicitud.id_nomina)
    this.totalAnticipos = this.data.reduce((total, item) => total + (item.autorizado ? item.total : 0), 0)
  }

  solicitar (importe) {
    this.desplegar = false
    if (!importe) return

    let data = {
      viaje: this.viaje,
      importe: importe,
    }

    this.ViaticosSolicitudAnticipoService.post(this.idProyecto, this.idColaborador, data, this.viaticoId)
      .then(({data}) => {
        this.viaticoId = data.viatico_id
        this.solicitudId = data.solicitud_id
        this.agregar(data)
      })
  }
}

module.component('viaticosSharedAnticipos', {
  controller: ViaticosSharedAnticiposComponent,
  template,
  bindings: {
    data: '<',
    idColaborador: '<',
    idProyecto: '<',
    comprobaciones: '<',
    informacion: '<',
    viaje: '<',
    viaticoId: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/anticipos/component.js